import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const sessionId = localStorage.getItem('sessionId');

  if (!sessionId) {
    // Redirect to login if session is invalid
    return <Navigate to="/" replace />;
  }

  // Render the child component if authenticated
  return children;
};

export default PrivateRoute;